export default {
  text: 'black',
  primary: '#da333f',
  secondary: 'rgb(202, 180, 146)',
  background: '#f3f3f3',
  backgroundSecondary: '#303030',
  light: '#f3f3f3',
  dark: '#303030'
}
